export default __webpack_public_path__ + "static/media/bodya.8b2ad723.png";